import { Urls } from '../../Shared/Api';

export default class ReviewsCarouselService {
    static getReviews() {
        return fetch(Urls.reviews.getLandingPageData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/LandingPage/LandingReviewsCarousel/ReviewsCarouselService.js